import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import authReducer from '../reducers/authReducer';
import customerType from '../reducers/customerTypeReducer'
import thunk from "redux-thunk";
import loadingReducer from "../reducers/loadingReducer";
import { composeWithDevTools } from "redux-devtools-extension";
import insuranceCompanyReducer from "../reducers/insuranceCompanyReducer";
import insuranceTypeReducer from "../reducers/insuranceTypeReducer";
import clientReducer from "../reducers/clientReducer";
import stateReducer from "../reducers/stateReducer";
import colorReducer from "../reducers/colorReducer";
import vehicleTypeReducer from "../reducers/vehicleTypeReducer";
import vehicleMakerReducer from "../reducers/vehicleMakerReducer";
import vendorReducer from "../reducers/vendorReducer";
import policeReducer from "../reducers/policeReducer";
import coverageReducer from "../reducers/coverageReducer";
import paymentTypeReducer from "../reducers/paymentTypeReducer";
import vehicleReducer from "../reducers/vehicleReducer";
import vehicleCodeReducer from "../reducers/vehicleCodeReducer";
import vehicleModelReducer from "../reducers/vehicleModelReducer";
import customerReducer from "../reducers/customerReducer";
import supplierReducer from "../reducers/supplierReducer";
import productCategoryReducer from "../reducers/productCategoryReducer";
import productReducer from "../reducers/productReducer";
import investigationReducer from "../reducers/investigationReducer";
import estimateReducer from "../reducers/estimateReducer";
import policeReportReducer from "../reducers/policeReportReducer";
import drivingLicenseReducer from "../reducers/drivingLicenseReducer";
import LpoReducer from "../reducers/LpoReducer";
import jobCardReducer from "../reducers/jobCardReducer";
import performaInvoiceReducer from "../reducers/performaInvoiceReducer";
import accidentTypeReducer from "../reducers/accidentTypeReducer";
import driverReducer from "../reducers/driverReducer";
import replaceableVehicleReducer from "../reducers/replaceableVehicleReducer";
import vehicleReplacementReducer from "../reducers/vehicleReplacementReducer";
import batchReducer from "../reducers/batchReducer";
import parallelJobReducer from "../reducers/parallelJobReducer";
import leaseBatchReducer from "../reducers/leaseBatchReducer";
import userReducer from "../reducers/userReducer";
import dashboardReducer from "../reducers/dashboardReducer";
import reportReducer from "../reducers/reportReducer";

const rootReducer = combineReducers(
    {
        loading: loadingReducer,
        auth: authReducer,
        dashboard: dashboardReducer,
        customerType: customerType,
        insuranceCompany: insuranceCompanyReducer,
        insuranceType: insuranceTypeReducer,
        client: clientReducer,
        state: stateReducer,
        color: colorReducer,
        vehicleType: vehicleTypeReducer,
        vehicleMaker: vehicleMakerReducer,
        vendor: vendorReducer,
        police: policeReducer,
        coverage: coverageReducer,
        paymentType: paymentTypeReducer,
        vehicle: vehicleReducer,
        vehicleCode: vehicleCodeReducer,
        vehicleModel: vehicleModelReducer,
        customer: customerReducer,
        supplier: supplierReducer,
        productCategory: productCategoryReducer,
        product: productReducer,
        investigation: investigationReducer,
        estimate: estimateReducer,
        policeReport: policeReportReducer,
        drivingLicense: drivingLicenseReducer,
        Lpo: LpoReducer,
        jobCard: jobCardReducer,
        performaInvoices: performaInvoiceReducer,
        accidentTypes: accidentTypeReducer,
        drivers: driverReducer,
        users: userReducer,
        replaceableVehicles: replaceableVehicleReducer,
        vehicleReplacements: vehicleReplacementReducer,
        batch: batchReducer,
        leaseBatch: leaseBatchReducer,
        parallelJob: parallelJobReducer,
        reports: reportReducer,
    }
);

const composeEnhancers = composeWithDevTools({
    trace: true,
});


const configureStore = () => {
    return createStore(rootReducer, compose(composeEnhancers(applyMiddleware(thunk))));
}

export default configureStore;